import { DbContext } from '../data/dbcontext.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LockDayFilters, LockedDaySummary } from '../../models/lock-day.models';
import { AppDataSyncService } from '../app-data-sync/app-data-sync.service';
import { LocalSaveService } from '../local/local-save.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { AppConfig } from '../../app/app.config';
import { TimeZoneService } from '../time-zone/time-zone.service';

@Injectable()
export class LockedDayService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
    private appDataSyncService: AppDataSyncService,
    private localSaveService: LocalSaveService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService
  ) {

  }

  async checkDay(editor: LockDayFilters): Promise<LockedDaySummary> {
    editor = await this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/lock/check/access`;
    const result = await this.http.post<LockedDaySummary>(url, editor).toPromise();

    return await this.dateParserService.deserializeDates(result, true, this.timeZoneService);
  }
}



// WEBPACK FOOTER //
// ./src/services/locked-day/locked-day.service.ts